
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { pseghrlyLoadsTbl } from '../Models/LoadsData';
import { PsegHrlyDemandService } from './pseg-hrly-demand.service';

@Injectable({
  providedIn: 'root'
})
export class PsegHrlyDemandResolverService implements Resolve<Array<pseghrlyLoadsTbl>> {
  PsegloadsData: Observable<Array<pseghrlyLoadsTbl>>;
  constructor(private psegHrlyLoadDemandSvc: PsegHrlyDemandService) { }
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<Array<pseghrlyLoadsTbl>> | Promise<Array<pseghrlyLoadsTbl>> | Array<pseghrlyLoadsTbl> {
    this.PsegloadsData= this.psegHrlyLoadDemandSvc.GetPsegHrlyLoadDemand();
    return this.PsegloadsData;
  }
}